import { clsx } from "clsx";
import { Flex } from "@/components/Flex/Flex";
import { Stack } from "@/components/Stack/Stack";
import { Text } from "@/components/Text";
import type { NotYetDevelopedProps } from "@/types/components";

export function NotYetDeveloped({
  type,
  props = {},
  className = "",
  ...restProps
}: NotYetDevelopedProps) {
  const propsString = JSON.stringify(props, null, 2);

  return (
    <div
      className={clsx(
        "border-warning bg-warning/5 my-8 rounded-lg border-2 border-dashed p-8",
        className,
      )}
      data-component="NotYetDeveloped"
      {...restProps}
    >
      <div className="mx-auto max-w-4xl">
        <Flex align="start" gap={16}>
          <div className="flex-shrink-0">
            <svg
              className="text-warning h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          <div className="flex-1">
            <Text as="h3" variant="subheading" className="text-warning-content mb-2">
              Component Not Yet Developed
            </Text>

            <Stack gap={8}>
              <p className="text-muted">
                The{" "}
                <code className="bg-bg rounded-lg px-2 py-1 font-mono text-(length:--type-body-sm)">
                  {type}
                </code>{" "}
                component is not yet implemented.
              </p>

              <details className="ds-collapse-arrow bg-bg ds-collapse rounded-lg">
                <summary className="ds-collapse-title cursor-pointer text-(length:--type-body-sm) font-(weight:--fw-medium)">
                  View Props
                </summary>
                <div className="ds-collapse-content">
                  <pre className="bg-bg mt-2 overflow-x-auto rounded-lg p-3 text-(length:--type-caption)">
                    <code>{propsString}</code>
                  </pre>
                </div>
              </details>

              <Text as="p" variant="body-sm" className="text-muted">
                This component will be developed soon. Check MISSING_COMPONENTS.md for details.
              </Text>
            </Stack>
          </div>
        </Flex>
      </div>
    </div>
  );
}

NotYetDeveloped.displayName = "NotYetDeveloped";

export default NotYetDeveloped;
